import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const CTA = () => {
  const [showComingSoonPopup, setShowComingSoonPopup] = useState(false);

  const handleAppStoreClick = () => {
    window.open('https://apps.apple.com/pt/app/am-cardmate/id6747951046', '_blank');
  };

  const handleGooglePlayClick = () => {
    window.open('https://play.google.com/store/apps/details?id=com.amcardmate.app', '_blank');
  };

  return (
    <section className="py-24 bg-gradient-blue-pink text-white text-center relative overflow-hidden">
      <div className="absolute inset-0 bg-dots-pattern opacity-15"></div>
      
      <div className="absolute top-20 left-10 w-24 h-24 rounded-full bg-white opacity-20"></div>
      <div className="absolute bottom-20 right-10 w-32 h-32 rounded-full bg-white opacity-10"></div>
      <div className="absolute top-1/3 right-1/4 w-16 h-16 rounded-full bg-white opacity-15"></div>
      
      <div className="container mx-auto px-6 relative z-10">
        <div className="max-w-3xl mx-auto">
          <h2 className="text-h2 mb-6">Ready to Transform Your Networking?</h2>
          
          <p className="text-body-lg text-white/90 mb-12">
            Download the AM CARDMATE app today, create your digital business card, and enhance your personal brand with our premium NFC cards.
          </p>
          
          <div className="flex flex-col sm:flex-row items-center justify-center gap-8">
            <button 
              onClick={() => setShowComingSoonPopup(true)}
              className="btn btn-lg btn-white hover:scale-105 transition-transform"
            >
              <FontAwesomeIcon icon="download" />
              <span>Get The App</span>
            </button>
          </div>
          
          <div className="mt-12 pt-10 border-t border-white/20 flex flex-wrap justify-center gap-6">
            <div className="flex items-center gap-2 text-white/80 hover:text-white transition-colors">
              <FontAwesomeIcon icon="check-circle" />
              <span className="text-body">No subscription required</span>
            </div>
            <div className="flex items-center gap-2 text-white/80 hover:text-white transition-colors">
              <FontAwesomeIcon icon="check-circle" />
              <span className="text-body">Cancel anytime</span>
            </div>
          </div>
        </div>
      </div>

      {showComingSoonPopup && (
        <div className="fixed inset-0 bg-gray-900/60 backdrop-blur-sm z-50 flex items-center justify-center p-4" onClick={() => setShowComingSoonPopup(false)}>
          <div className="bg-white rounded-3xl p-6 sm:p-8 max-w-md w-full shadow-2xl" onClick={(e) => e.stopPropagation()}>
            <div className="text-center">
              <div className="w-16 sm:w-20 h-16 sm:h-20 bg-gradient-to-br from-blue-500 to-purple-600 rounded-full flex items-center justify-center mx-auto mb-6">
                <FontAwesomeIcon icon="rocket" className="text-white text-2xl sm:text-3xl" />
              </div>
              
              <h3 className="text-h3 text-dark mb-4">Download AM CARDMATE</h3>
              <p className="text-body text-gray mb-8">
                AM CARDMATE is available on both App Store and Google Play!
              </p>
              
              <div className="grid grid-cols-1 gap-3 mb-6">
                <button 
                  onClick={handleAppStoreClick}
                  className="flex items-center gap-4 bg-black px-6 py-4 rounded-xl hover:bg-gray-900 transition-all"
                >
                  <FontAwesomeIcon icon={['fab', 'apple']} className="text-3xl text-white" />
                  <div className="text-left text-white">
                    <div className="text-caption text-white/80">Download on the</div>
                    <div className="text-btn-lg">App Store</div>
                  </div>
                </button>
                
                <button 
                  onClick={handleGooglePlayClick}
                  className="flex items-center gap-4 bg-black px-6 py-4 rounded-xl hover:bg-gray-900 transition-all"
                >
                  <FontAwesomeIcon icon={['fab', 'google-play']} className="text-3xl text-white" />
                  <div className="text-left text-white">
                    <div className="text-caption text-white/80">GET IT ON</div>
                    <div className="text-btn-lg">Google Play</div>
                  </div>
                </button>
              </div>
              
              <div className="space-y-3">
                <button className="w-full py-3 bg-gradient-to-r from-blue-500 to-purple-600 text-white rounded-xl text-btn hover:from-blue-600 hover:to-purple-700 transition-all" onClick={() => setShowComingSoonPopup(false)}>
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default CTA;